import Bowser from 'bowser';
import constant from 'lodash/constant';

/*
 * Browser
 */

const bowser = Bowser.getParser(window.navigator.userAgent);

export const isDesktop = constant(bowser.is('desktop'));
export const isEdge = constant(bowser.is('edge'));
export const isIE = constant(bowser.is('ie'));

/*
 * Feature detection
 */

export const isObjectFitSupported = constant('objectFit' in document.documentElement.style);
